const doc = [({"en":({"js":({"admin":({"economy":({"index":({"economy":"Economy"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;